import { fade } from "svelte/transition";
import { createReduced } from "./createReduced";

export const fadeReduced = createReduced(fade);
